/** "12 minutes ago", "3 days ago". Past instants only; a future one reads "just now". */
export function timeAgo(input: string | number | Date | undefined | null, now: number = Date.now()): string {
  if (input === undefined || input === null || input === '') return '';
  const then = input instanceof Date ? input.getTime() : new Date(input).getTime();
  if (!Number.isFinite(then)) return '';
  const seconds = Math.max(0, Math.round((now - then) / 1000));
  if (seconds < 45) return 'just now';
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours} h ago`;
  const days = Math.round(hours / 24);
  if (days < 45) return `${days} d ago`;
  const months = Math.round(days / 30.4);
  if (months < 12) return `${months} mo ago`;
  return `${Math.round(days / 365)} y ago`;
}

/** "49m 11s", "1h 02m". A run still in progress passes `end` as undefined. */
export function formatDuration(startIso?: string, endIso?: string, now: number = Date.now()): string {
  if (!startIso) return '';
  const start = new Date(startIso).getTime();
  const end = endIso ? new Date(endIso).getTime() : now;
  if (!Number.isFinite(start) || !Number.isFinite(end)) return '';
  return formatSeconds(Math.max(0, Math.round((end - start) / 1000)));
}

export function formatSeconds(total: number): string {
  const s = Math.max(0, Math.round(total));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) return `${h}h ${String(m).padStart(2, '0')}m`;
  if (m > 0) return `${m}m ${String(sec).padStart(2, '0')}s`;
  return `${sec}s`;
}

const NZ_DATE_TIME = new Intl.DateTimeFormat('en-NZ', {
  timeZone: 'Pacific/Auckland',
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
});
const NZ_DATE = new Intl.DateTimeFormat('en-NZ', {
  timeZone: 'Pacific/Auckland',
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});

/** "13 Oct 2026, 8:49 am", always in New Zealand time. */
export function formatNzDateTime(input?: string | number | Date | null): string {
  if (input === undefined || input === null || input === '') return '';
  const d = input instanceof Date ? input : new Date(input);
  return Number.isFinite(d.getTime()) ? NZ_DATE_TIME.format(d) : '';
}

/** "13 Oct 2026", always in New Zealand time. */
export function formatNzDate(input?: string | number | Date | null): string {
  if (input === undefined || input === null || input === '') return '';
  const d = input instanceof Date ? input : new Date(input);
  return Number.isFinite(d.getTime()) ? NZ_DATE.format(d) : '';
}
